import { Builder } from '@builder.io/react';

import ImageBlock from './index.tsx';

Builder.registerComponent(ImageBlock, {
  name: 'ImageBlock',
  inputs: [
    {
      name: 'image',
      type: 'file',
      defaultValue: '/static/images/gradient.png'
    },
    {
      name: 'height',
      type: 'number',
      defaultValue: '800'
    },
    {
      name: 'width',
      type: 'number',
      defaultValue: '1200'
    },
    {
      name: 'alt',
      type: 'string',
      defaultValue: 'Alt Descriptor'
    }
  ]
});
